import { render, staticRenderFns } from "./Port.vue?vue&type=template&id=0cc0c12f&scoped=true&"
import script from "./Port.vue?vue&type=script&lang=js&"
export * from "./Port.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0c12f",
  null
  
)

export default component.exports